export class PayeeSector {
    id: number;
    code:string
    name: string;
    higher_sector:string;
    activities:[];
    description: string;
  }
  